import {Component,  OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { VersionCheckService } from '../services/version-check.service';
import { ConnectionService } from 'ng-connection-service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/services';
import { AnalyticsService } from 'src/services/analytics.service';
import { Gtag } from 'angular-gtag';
import { filter, map } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit
{
  title = 'Lynkgrid';
  isConnected:any=true;
  private routerSubscription!: Subscription;
  // private gtag: Gtag,
  constructor(private versionCheckService: VersionCheckService,private router: Router,  private connectionService: ConnectionService,private titleService: Title,
     private service: AuthService,) 
  { 
    // this.connectionService.monitor().subscribe(isConnected=>
    // {
    //   this.isConnected = isConnected;
    //   if (isConnected)
    //   {
    //     this.service.showToast('Success','Internet connection is back' )
    //   }
    //   else
    //   {
    //     this.service.showToast('error', 'Internet connection is lost' )
    //   }
    // })
  }

  ngOnInit() 
  {
    this.routerSubscription = this.router.events .pipe( filter((event): event is NavigationEnd => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => 
    {
      // console.log(111,event instanceof NavigationEnd);
      
      if (!(event instanceof NavigationEnd)) 
      {
        return;
      }
      // gtag('config', 'WKR25Z6JKN', {  // for live
      // 	page_path: event.urlAfterRedirects,
      // 	page_title: this.getRouteSnapshot().data.title
      // }); 
      setTimeout(() => 
      {

        var sidebar_hide = document.querySelector('#sidebar-hide');
        
        if (sidebar_hide) 
        {
          sidebar_hide.addEventListener('click',  () => 
          {
            hideSideBarDesktop();
          });
        }

        var mobile_collapse_over = document.querySelector('#mobile-collapse');
        if (mobile_collapse_over) 
        {
          mobile_collapse_over.addEventListener('click', function () 
          {
            hideSideBarMobile();
          });
        }

        // const title = this.getRouteTitle(this.router.routerState.snapshot.root);
        
        // const pageTitle = this.titleService.getTitle();
        
        // if (this.gtag) 
        // {
        //   this.gtag.pageview({
        //     page_path: event.urlAfterRedirects,
        //     page_title: title ? title : pageTitle,
        //     debug_mode: !environment.production
        //   });

        //   this.gtag.event('page_view', {
        //     page_path: event.urlAfterRedirects,
        //     page_title: this.getRouteTitle(this.router.routerState.snapshot.root)
        //   });
        //   console.log('title ::', title, 'pageTitle', pageTitle);
        // }
        // else 
        // {
        //   console.error('gtag is not defined');
        // }

        // gtag('config', 'PM8BKCMP8T', {  // for Test
        // 	page_path: event.urlAfterRedirects,
        // 	page_title: this.getRouteSnapshot().data.title
        // });
      }, 500)
    });

    this.versionCheckService.initVersionCheck(
			environment.versionCheckURL,
			1000 * 60 * 30
		);

  }

  getRouteTitle(route: any): string {
		while (route.firstChild) {
			route = route.firstChild;
		}
		return route.data && route.data['title'] && route.data?.['title'] || '';
	}

	getRouteSnapshot() {
		let route = this.router.routerState.snapshot.root;
		while (route.firstChild) {
			route = route.firstChild;
		}
		return route;
	}

  ngOnDestroy(): void {
		if (this.routerSubscription) {
			this.routerSubscription.unsubscribe();
		}
	}
}
function hideSideBarMobile() 
{
  var temp_sidebar = document.querySelector('.pc-sidebar');
  if (temp_sidebar) 
  {
    if (document.querySelector('.pc-sidebar').classList.contains('mob-sidebar-active')) {
      rm_menu();
    } 
    else 
    {
      document.querySelector('.pc-sidebar').classList.add('mob-sidebar-active');
      document.querySelector('.pc-sidebar').insertAdjacentHTML('beforeend', '<div class="pc-menu-overlay"></div>');

      if(document.querySelector('.pc-menu-overlay'))
      {
        document.querySelector('.pc-menu-overlay').addEventListener('click', function () 
        {
          rm_menu();
  
          if(document.querySelector('.hamburger'))
          {
            document.querySelector('.hamburger').classList.remove('is-active');
          }
        });
      }
    }
  }
}

function rm_menu() 
{
  var temp_list = document.querySelector('.pc-sidebar');
  if (temp_list) 
  {
    document.querySelector('.pc-sidebar').classList.remove('mob-sidebar-active');
  }
  
  if (document.querySelector('.topbar')) 
  {
    document.querySelector('.topbar').classList.remove('mob-sidebar-active');
  }

  if( document.querySelector('.pc-sidebar .pc-menu-overlay'))
  {
    document.querySelector('.pc-sidebar .pc-menu-overlay').remove();
  }

  if(document.querySelector('.topbar .pc-menu-overlay'))
  {
    document.querySelector('.topbar .pc-menu-overlay').remove();
  }
}

function hideSideBarDesktop() {
  if (document.querySelector('.pc-sidebar')?.classList.contains('pc-sidebar-hide')) {
    document.querySelector('.pc-sidebar')?.classList.remove('pc-sidebar-hide');
    document.querySelector('.pc-header')?.classList.remove('pc-header-hide');
    document.querySelector('.pc-container')?.classList.remove('pc-container-hide');
  }

  else {
    document.querySelector('.pc-sidebar')?.classList.add('pc-sidebar-hide');
    document.querySelector('.pc-header')?.classList.add('pc-header-hide');
    document.querySelector('.pc-container')?.classList.add('pc-container-hide');
  }
}

